const consentPopupStyles = {
  dialogTitleRoot: {
    marginTop: '5px',
    paddingBottom: '5px',
  },
  dialogContentRoot: {
    paddingBottom: 15,
  },
  title: {
    fontWeight: 500,
    fontSize: '22px',
  },
  subtitle: {
    marginTop: '0px',
    marginBottom: '12px',
  },
  tosScroll: {
    border: '1px solid #ddd',
    borderRadius: 4,
    padding: 12,
    maxHeight: 280,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 16,
  },
  sectionHeader: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.6,
    color: '#888',
    marginTop: 4,
    marginBottom: 4,
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 8,
  },
  checkboxText: {
    fontSize: 13,
    lineHeight: 1.4,
    flex: 1,
  },
  requiredStar: {
    color: '#E0726E',
    fontWeight: 700,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12,
  },
}

export default consentPopupStyles
